/* src/app/components/shared/text-sms-verify-dialog/text-sms-verify-dialog.component.scss */
#smsPanel .txt-center {
  text-align: center;
}
#smsPanel .smsInputButton {
  background-color: var(--theme-deafult-secondary);
  width: 85px;
  padding: 7px;
  border-radius: 15px;
  text-align: center;
  margin-left: 120px;
  margin-top: 20px;
  color: white;
}
/*# sourceMappingURL=text-sms-verify-dialog.component.css.map */
